const bu = 12 // 1 BU = 12px

export default bu
